import DOMPurify from 'dompurify';

const DEFAULT_SANITIZE_CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ['button', 'embed', 'form', 'iframe', 'input', 'object', 'script', 'style'],
  FORBID_ATTR: ['style'],
};

export const sanitizeHtml = (html, config = DEFAULT_SANITIZE_CONFIG) => (
  DOMPurify.sanitize(String(html ?? ''), config)
);
